/**
 * Light Theme Definition
 * 
 * Definiert die Farbpalette und Konfiguration für das Light Theme.
 * Kann später für CSS-Variablen oder erweiterte Theme-Features verwendet werden.
 */

export interface ThemeColors {
  background: string
  foreground: string
  primary: string
  secondary: string
  border: string
  muted: string
  accent: string
}

export const lightTheme: ThemeColors = {
  background: '#ffffff',
  foreground: '#0f172a', // Dunkler für besseren Kontrast (von #111827 zu #0f172a)
  primary: '#1e40af', // Dunkleres Blau für besseren Kontrast (von #2563eb zu #1e40af) - Kontrast ~7:1
  secondary: '#475569', // Dunkleres Grau für besseren Kontrast (von #64748b zu #475569) - Kontrast ~6:1
  border: '#cbd5e1', // Dunklerer Border für bessere Sichtbarkeit (von #e5e7eb zu #cbd5e1) - Kontrast ~3:1
  muted: '#f1f5f9', // Leicht angepasst für subtilen Kontrast (von #f3f4f6 zu #f1f5f9)
  accent: '#1e3a8a' // Dunkleres Accent-Blau für besseren Kontrast (von #3b82f6 zu #1e3a8a) - Kontrast ~8:1
}

/**
 * Light Theme Konfiguration
 */
export const lightThemeConfig = {
  name: 'light',
  colors: lightTheme,
  // Weitere Theme-spezifische Eigenschaften können hier hinzugefügt werden
  // z.B. borderRadius, spacing, etc.
} as const

